<template>
    <div class="checkbox">
        <label>
            <slot></slot> {{ label }}
            <slot name="description"></slot>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: null,
        },
    },
}
</script>